import React,{useEffect} from 'react';
import {HashRouter as Router,Routes,Route,useLocation} from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Contact from './pages/Contact';
import DigitalTransformation from './pages/DigitalTransformation';
import BusinessTraining from './pages/BusinessTraining';
import NoCodeDevelopment from './pages/NoCodeDevelopment';
import Nigeria from './pages/Nigeria';
import BookConsultation from './pages/BookConsultation';
import EngagementGrowthEngine from './pages/EngagementGrowthEngine';

// Component to handle scroll to top on route change
function ScrollToTop() {
  const {pathname}=useLocation();
  useEffect(()=> {
    window.scrollTo(0,0);
  },[pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/digital-transformation-consulting" element={<DigitalTransformation />} />
            <Route path="/business-training-certification" element={<BusinessTraining />} />
            <Route path="/no-code-development" element={<NoCodeDevelopment />} />
            <Route path="/nigeria" element={<Nigeria />} />
            <Route path="/book-consultation" element={<BookConsultation />} />
            <Route path="/engagement-growth-engine" element={<EngagementGrowthEngine />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;